import {
  ConditionDTO,
  ConflictResolutionType,
  ExtendedIngredientDTO,
  IngredientConflictDto,
  IngredientStockDTO,
  VendorDTO,
} from 'business/models/Models';

export interface NewIngredientProps {
  vendorStock: string;
  vendors: VendorDTO[];
  setVendorStock: (value: string) => void;
  setIsUseVendorStock: (Values: boolean) => void;
  setIsAddMissingStock: (Values: boolean) => void;
  isAddMissingStock: boolean;
  isUseVendorStock: boolean;
  onChangeIngredientType: (value: ConflictResolutionType) => void;
}

export interface SubstituteIngredientProps {
  matchedIngredients: ExtendedIngredientDTO[];
}

export interface IngredientsConflictsModelProps {
  nonConflictIngredientsList: IngredientConflictDto[];
  conflictIngredientsList: IngredientConflictDto[];
  resolvedIngredientsList: IngredientConflictDto[];
  setNonConflictIngredientsList: (value: IngredientConflictDto[]) => void;
  setConflictIngredientsList: (value: IngredientConflictDto[]) => void;
  setResolvedIngredientsList: (value: IngredientConflictDto[]) => void;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  vendors: VendorDTO[];
  saveIngredients: () => Promise<void>;
  isScreen: boolean;
  conditions?: ConditionDTO[];
  setConditions?: (value: ConditionDTO[]) => void;
  hasAdditionalStock?: boolean;
}

export interface StocksTableProps {
  ingredientStocks: IngredientStockDTO[];
  selectedIds: number[];
  setSelectedIds?: (value: number[]) => void;
}

export class KeyValuePairDTO {
  id: number;
  value: ConflictResolutionType;
  name: string;
  constructor(data?: KeyValuePairDTO) {
    if (data) {
      this.id = +data.id;
      this.name = data.name;
      this.value = data.value;
    }
  }
}

export interface IngredientsDetailsProps {
  conflictResolutionType: ConflictResolutionType;
  selectedIngredient?: ExtendedIngredientDTO;
  setSelectedIngredient: (value: ExtendedIngredientDTO) => void;
  setSelectedTypes: (values: KeyValuePairDTO[]) => void;
  selectedTypes: KeyValuePairDTO[];
  setSelectedAliases: (values: KeyValuePairDTO[]) => void;
  selectedAliases: KeyValuePairDTO[];
  setSelectedCasNumbers: (values: KeyValuePairDTO[]) => void;
  selectedCasNumbers: KeyValuePairDTO[];
  setSelectedBufferData: (values: KeyValuePairDTO[]) => void;
  selectedBufferData: KeyValuePairDTO[];
  onClickAddTypes: (value: ConflictResolutionType) => void;
  onClickAddAliases: (value: ConflictResolutionType) => void;
  onClickAddCasNumbers: (value: ConflictResolutionType) => void;
  onClickAddBufferData: (value: ConflictResolutionType) => void;
  onClickDeleteTypes: (value: ConflictResolutionType) => void;
  onClickDeleteAliases: (value: ConflictResolutionType) => void;
  onClickDeleteCasNumbers: (value: ConflictResolutionType) => void;
}

export interface IngredientItemsListProps {
  name: string;
  iterator: any;
  selectedItems: KeyValuePairDTO[];
  onClickAdd: (value: any) => void;
  onClickDelete: (value: any) => void;
  callbackMethod: (value: any) => void;
  showAddButton?: boolean;
  conflictResolutionType?: ConflictResolutionType;
  selectOrUnselect: (selectedItems: any, value: any) => any;
}
